module.exports = __webpack_public_path__ + "media/images/order/waiting_review-a24a26210236f14ea2c15d60ec55dba0.jpg";